'use client';

import useSWR from 'swr';
import { categoryBudgetApi } from '@/lib/api';
import { localCalendarDate } from '@/lib/calendarScope';
import type { CategoryOverviewResponse } from '@/types';
import { TRANSACTION_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

export type CategoryOverviewScope = {
  year?: number;
  month?: number;
  from?: Date;
  to?: Date;
  budgetMonths?: number;
};

export function useCategoryOverview(scope: CategoryOverviewScope | null) {
  const authedFetch = useAuthedFetcher();

  const key = scope
    ? [
        'category-overview',
        scope.from && scope.to
          ? `${scope.from.getTime()}-${scope.to.getTime()}-${scope.budgetMonths ?? ''}`
          : `${scope.year}-${scope.month}`,
      ]
    : null;

  // The elapsed days (and, with no month asked, the month) count from the user's local day, read at
  // fetch time: the server's UTC day is already tomorrow late in the evening west of UTC.
  return useSWR<CategoryOverviewResponse>(
    key,
    () => authedFetch((token) => categoryBudgetApi.getOverview(token, { ...scope!, today: localCalendarDate() })),
    TRANSACTION_SWR_OPTIONS,
  );
}
